"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
var _ckeditor5Vue = _interopRequireDefault(require("@ckeditor/ckeditor5-vue2"));
var _ckeditor = _interopRequireDefault(require("./ckeditor"));
var _preview = _interopRequireDefault(require("./components/preview"));
var _imageUploadAdapter = _interopRequireDefault(require("./components/imageUploadAdapter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
var _default = exports.default = {
  name: 'CkEditor',
  components: {
    // Use the <ckeditor> component in this view.
    ckeditor: _ckeditor5Vue.default.component,
    PreviewBox: _preview.default
  },
  data: function data() {
    var _this = this;
    return {
      loadingComponent: null,
      isLoading: false,
      form: {
        appMessagePk: null,
        appMessagePage: ''
      },
      editorObject: null,
      // editor
      editor: _ckeditor.default,
      initEditorData: '',
      editorData: '',
      uploadFileType: '',
      editorConfig: {
        // 自定义的全部显示配置
        uploadVideo: {
          // 点击按钮后会执行的回调函数
          handler: function handler() {
            // 控制用于视频上传
            _this.clickUploadVideoBtn();
          }
        },
        uploadAttachment: {
          // 点击按钮后会执行的回调函数
          handler: function handler() {
            // 控制用于文件上传
            _this.uploadFileType = '';
            _this.$nextTick(function () {
              _this.clickUploadAttachmentBtn();
            });
          }
        },
        pdf: {
          // 点击按钮后会执行的回调函数
          handler: function handler() {
            // 控制用于pdf上传
            _this.uploadFileType = '.pdf';
            _this.$nextTick(function () {
              _this.clickUploadAttachmentBtn();
            });
          }
        }
      },
      imgFormData: null,
      imagePath: '',
      hasWaterMark: false,
      dialogVisible: false
    };
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.form.appMessagePk = this.$route.query.appMessagePk || null;
    this.fetchData();
  },
  methods: {
    onReady: function onReady(editor) {
      var _this2 = this;
      var that = this;
      this.editorObject = editor;
      console.log('-------onReady----', editor);
      if (this.form.appMessagePk) {
        editor.plugins.get('FileRepository').createUploadAdapter = function (loader) {
          return new _imageUploadAdapter.default(loader, _this2.form.appMessagePk, 'cms_internal_message', that);
        };
      }

      // 监听模块的点击事件
      editor.editing.view.document.on('click', function (evt, data) {
        var list = ['attachment-title']; // 'attachment-box', 'attachment-icon',
        if (list.includes(data.domTarget.className)) {
          // to do something
          // console.log('----edit--name=---edit--', evt, data)
          var uuid = data.domTarget.children[0].innerText;
          console.log('----uuid--', uuid);
          _this2.downloadAttachment(uuid);
        }
      });
    },
    fetchData: function fetchData() {
      var _this3 = this;
      if (this.form.appMessagePk) {
        this.isLoading = true;
        this.$api.notice.getPageDetail(this.form.appMessagePk).then(function (res) {
          _this3.isLoading = false;
          _this3.editorData = res.data.appMessagePage || '';
          _this3.initEditorData = _this3.editorData;
          _this3.form.appMessagePage = _this3.editorData;
        }).catch(function () {
          _this3.isLoading = false;
        });
      }
    },
    create: function create() {
      var _this4 = this;
      if (!this.editorData) {
        this.$message.error(this.$t('sfe.noticeContent.error.empty'));
        return;
      }
      this.isLoading = true;
      this.form.appMessagePage = this.editorData;
      this.$api.notice.saveArticle(this.form).then(function (res) {
        _this4.isLoading = false;
        _this4.$router.go(-1);
      }).catch(function () {
        _this4.isLoading = false;
      });
    },
    preview: function preview() {
      this.dialogVisible = true;
    },
    back: function back() {
      var _this5 = this;
      if (this.initEditorData.length === this.editorData.length) {
        this.$router.go(-1);
        return;
      }
      this.$confirm(this.$t('sfe.noticeContent.dialog.back'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this5.$router.go(-1);
      }).catch(function () {});
    },
    clickUploadVideoBtn: function clickUploadVideoBtn() {
      this.$refs.uploadVideoFileInput.click();
    },
    uploadVideoFileChange: function uploadVideoFileChange(e) {
      console.log(e);
      var file = e.target.files[0];
      if (!file) return;
      var before = this.beforeUpload(file);
      if (before) {
        this.uploadVideo(file);
      } else {
        this.$refs.uploadVideoFileInput.value = '';
      }
    },
    beforeUpload: function beforeUpload(file) {
      // const isLt1M = file.size / 1024 / 1024 < 30

      // if (isLt1M) {
      return true;
      // }

      // this.$message({
      //   message: '上传文件不能大于30M',
      //   type: 'warning'
      // })
      // return false
    },
    uploadVideo: function uploadVideo(file) {
      var _this6 = this;
      var param = new FormData();
      param.append('file', file);
      param.append('businessKey', this.form.appMessagePk);
      param.append('resourceConfigFlag', 'cms_internal_message');
      this.isLoading = true;
      this.$api.common.uploadFile(param).then(function (res) {
        _this6.isLoading = false;
        var url = res.data.url;

        // this.editorData += `<div data-oembed-url="${url}"></div>`
        _this6.$refs.uploadVideoFileInput.value = '';
        _this6.editorObject.model.change(function (writer) {
          _this6.editorObject.model.insertContent(_this6.createVideoBox(writer, url));
        });
      }).catch(function () {
        _this6.isLoading = false;
        _this6.$refs.uploadVideoFileInput.value = '';
        // this.$message.error('保存失败')
      });
    },
    createVideoBox: function createVideoBox(writer, url) {
      var mediaElement = writer.createElement('media', {
        url: url
      });
      return mediaElement;
    },
    clickUploadAttachmentBtn: function clickUploadAttachmentBtn() {
      // console.log(this.editor)
      this.$refs.uploadFileInput.click();
      // const file = {
      //   name: 'demo.txt'
      // }
      // const uuid = '8bf59985-5270-4fbd-a96c-1d73ea543190'
      // this.editorData += `<div class="attachment-box"><div class="attachment-icon">附件：</div><div class="attachment-title">${file.name}<div class="attachment-uu-box">${uuid}</div></div></div>`
    },
    uploadFileChange: function uploadFileChange(e) {
      console.log(e);
      var file = e.target.files[0];
      if (!file) return;
      var before = this.beforeUpload(file);
      if (before) {
        this.uploadAttachment(file);
      } else {
        this.$refs.uploadFileInput.value = '';
      }
    },
    createAttachmentBox: function createAttachmentBox(writer, title, uuid) {
      var attachmentBox = writer.createElement('attachmentBox');
      var attachmentIcon = writer.createElement('attachmentIcon');
      var attachmentTitle = writer.createElement('attachmentTitle');
      var attachmentUuBox = writer.createElement('attachmentUuBox');
      writer.insertText(this.uploadFileType ? this.$t('sfe.noticeContent.form.view') : this.$t('sfe.noticeContent.form.attachment'), writer.createPositionAt(attachmentIcon, 0));
      writer.insertText(title, writer.createPositionAt(attachmentTitle, 0));
      writer.insertText(uuid, writer.createPositionAt(attachmentUuBox, 0));
      writer.append(attachmentIcon, attachmentBox);
      writer.append(attachmentUuBox, attachmentTitle);
      writer.append(attachmentTitle, attachmentBox);
      return attachmentBox;
    },
    uploadAttachment: function uploadAttachment(file) {
      var _this7 = this;
      var param = new FormData();
      param.append('file', file);
      param.append('businessKey', this.form.appMessagePk);
      param.append('resourceConfigFlag', 'cms_internal_message');
      param.append('permission', this.uploadFileType ? 'view' : '');
      this.isLoading = true;
      this.$api.common.uploadFile(param).then(function (res) {
        _this7.isLoading = false;
        console.log('attachment----');
        var uuid = res.data.uuid;
        // this.editorData += `<div class="attachment-box"><div class="attachment-icon">附件：</div><div class="attachment-title">${file.name}<div class="attachment-uu-box">${uuid}</div></div></div>`
        _this7.$refs.uploadFileInput.value = '';
        _this7.editorObject.model.change(function (writer) {
          _this7.editorObject.model.insertContent(_this7.createAttachmentBox(writer, file.name, uuid));
        });
      }).catch(function () {
        _this7.isLoading = false;
        _this7.$refs.uploadFileInput.value = '';
        // this.$message.error('保存失败')
      });
    },
    downloadAttachment: function downloadAttachment(uuid) {
      var _this8 = this;
      this.isLoading = true;
      this.$api.common.downloadFile(uuid).then(function (res) {
        _this8.isLoading = false;
        location.href = res.data + '&token=' + _this8.$store.getters.sasToken;
      }).catch(function () {
        _this8.isLoading = false;
      });
    }
  }
};